<template>
  <div v-if="loadingShow">
    <Spin fix>
      <div style="display: flex;flex-direction: column;align-items: center;height: 100%;justify-content: center;">
      <Icon type="load-c" size=30 class="demo-spin-icon-load"></Icon>
      <div style="font-size:20px">Loading</div>
      </div>
    </Spin>
  </div>
</template>

<script>
  export default {
    name: "loading",
    computed: {
      loadingShow() {
        return this.$store.state.loadingShow
      }
    }
  }
</script>

<style>
  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }

  @keyframes ani-demo-spin {
    from {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .demo-spin-col {
    width: 100%;
    height: 100%;
    position: relative;
    border: 1px solid #eee;
    z-index: 100000000;
  }

  .ivu-spin-fix {
    /*height: 100vh;*/
  }

  .ivu-spin-fix .ivu-spin-main {
    width: 100%;
    height: 100%;
  }

  .ivu-spin-text{
  height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/loading.vue